import { User } from "oidc-client-ts";
import { useEffect, useState, useMemo } from "react";
import { useAuth, AuthContextProps } from "react-oidc-context";
import Util from "../services/Util";

// A definição que estava no seu código original.
type AuthUser = User | null | undefined;

// Chave para salvar o token no sessionStorage.
const AZURE_TOKEN_STORAGE_KEY = 'portal_azure_token';

const usePortalAuth = (): AuthContextProps => {
    const auth = useAuth();

    const [customToken, setCustomToken] = useState<string | null>(() => {
        // Ao carregar, também verifica se o token no storage ainda é válido.
        const tokenFromStorage = sessionStorage.getItem(AZURE_TOKEN_STORAGE_KEY);
        if (Util.isJwtTokenValid(tokenFromStorage)) {
            return tokenFromStorage;
        }
        // Se for inválido, limpa do storage.
        sessionStorage.removeItem(AZURE_TOKEN_STORAGE_KEY);
        return null;
    });


    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tokenFromUrl = params.get("token_azure");

        if (tokenFromUrl && Util.isJwtTokenValid(tokenFromUrl)) {
            sessionStorage.setItem(AZURE_TOKEN_STORAGE_KEY, tokenFromUrl);
            setCustomToken(tokenFromUrl);
        }
    }, []);

    const isAuthenticated = useMemo(() => 
        !!customToken || auth.isAuthenticated, 
        [customToken, auth.isAuthenticated]
    );

    // Agora a anotação de tipo : AuthUser faz sentido.
    const user = useMemo((): AuthUser => {
        if (customToken) {
            return {
                ...(auth.user || {}),
                access_token: customToken,
            } as User;
        }
        return auth.user;
    }, [customToken, auth.user]);

    return useMemo(() => ({
        ...auth,
        isAuthenticated,
        user,
        signoutRedirect: async (args?: any) => {
            sessionStorage.removeItem(AZURE_TOKEN_STORAGE_KEY);
            return auth.signoutRedirect(args);
        },
    }), [auth, isAuthenticated, user]);
};

export default usePortalAuth;